import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import img from '../../assets/fotojr1.jpg'
import '../curriculo/Curriculo.css'

export default function ImgMediaCard() {
  return (
    <Card elevation={3} sx={{ marginTop:0, bgcolor: 'whithe', border: 0, borderColor: 'lightgray', fontFamily:'Lucida Sans' }}>
      
      <CardContent>

        <Typography gutterBottom variant="h4" component="div" sx={{ fontWeight: 'bold', margin:1, marginBottom:0, fontFamily: 'arial', color:'#07498b'}}>
          Formação profissional
        </Typography>

        <Typography gutterBottom variant="h6" component="div" sx={{ margin:1, marginTop:0, marginBottom:4, fontWeight: '600', fontFamily: 'arial', color:'#07498b'}}>
          Médico - Hepatologista e Gastroenterologista
        </Typography>

        <Typography variant="body1" color="black" sx={{ margin:1, color:'#07498b', fontFamily:'arial'}}>
        •	Formado em Medicina pela Universidade Federal da Paraíba (UFPB)   
        </Typography>
        
        <Typography variant="body1" color="black" sx={{ margin:1, color:'#07498b'}}>
        •	Residência médica em Clínica Médica pelo Hospital Getúlio Vargas em Recife – PE   
        </Typography>

        <Typography variant="body1" color="black" sx={{ margin:1, color:'#07498b'}}>
        •	Residência médica em Gastroenterologia/Hepatologia pela Universidade de São Paulo (USP – RP) 
        </Typography>

        <Typography variant="body1" color="black" sx={{ margin:1, color:'#07498b'}}>
        •	Residência médica em Endoscopia digestiva pela Universidade Federal do Paraná (UFPR)
        </Typography>

        <Typography variant="body1" color="black" sx={{ margin:1, color:'#07498b'}}>
        •	Sócio titular da Sociedade Brasileira de Hepatologia
        </Typography>

        <Typography variant="body1" color="black" sx={{ margin:1, color:'#07498b'}}>
        •	Encarregado do serviço de Endoscopia digestiva e Gastroenterologia do Hospital Naval de Natal
        </Typography>

        <Typography variant="body1" color="black" sx={{ margin:1, color:'#07498b'}}>
        •	Médico militar da Marinha do Brasil
        </Typography>

       

      </CardContent>
     
    </Card>
  );
}